import Image from 'next/image';

import useUserContext from '@/hooks/useUserContext';
import { cn } from '@/lib/utils';
import defaultAvatar from '../../../public/admin/default-avatar.png';

export default function UserAvatarRoot() {
  const { userGrant } = useUserContext();

  return (
    <Image
      alt="avatar"
      src={defaultAvatar}
      className={cn(
        '!w-10 !h-[40px] object-fill rounded-[50%] inline-block align-middle',
        {
          'border-2 border-error-primary': userGrant && userGrant === 'admin',
        },
      )}
    />
  );
}
